import React from 'react';
import { connect } from 'react-redux';
import { goBack, push } from "connected-react-router";

import MobileWindow from './../Wrappers/MobileWindow';
import SnapshotVideo from './../Report/Snapshot/SnapshotVideo';
import logo from '../../svg/nc-logo.svg';
import { formatBigNumber, imageFix } from '../../helpers';
import './Results.css';

interface Props {
  id: string;
  post: any;
  history?: any;
  goBack: any;
}
interface State {
  dates: Array<any>;
  post: any;
}

class InstagramResult extends React.Component<Props, State> {
  height: number;

  constructor(props: Props) {
    super(props);
    this.state = { dates: [], post: props.post };
    this.height = window.innerHeight;
  }

  download() {
    var link = document.createElement('a');
    link.href = imageFix(this.state.post.media.resource_url);
    link.download = this.state.post.media.resource_url.split('/').pop();
    document.body.appendChild(link);
    link.click();
  }

  render() {

    if (!this.state.post) {

      this.setState({
        ...this.state,
        post: JSON.parse(localStorage.getItem('currentInstagramPost') as string),
      });

      return (
        <MobileWindow page="monthlyReport">
          <img
            src={logo}
            alt="logo"
            className=""
            style={{ marginLeft: '30px', marginTop: '45px', width: '75px' }}
          />
          <div className="instagram-result-title">IG ACTION - ORGANIC RESULTS</div>
          <div className="offer-loader" style={{ fontSize: '20px', paddingTop: '100px' }}>
            Loading results...
          </div>
        </MobileWindow>
      );
    }

    const isFullPost = ['gallery_video', 'gallery_photo', 'photo', 'video'].includes(
      this.state.post.type
    );

    return [
      <div style={{ width: '100%', minHeight: '100vh' }}>
        <div className="instagram-post-close" onClick={this.props.goBack}>
          ×
        </div>
        {isFullPost ? (
          <div className="full-post-info">
            <div style={{ fontFamily: 'BrandonGrotesque-Medium', color: '#333333' }}>GRID POST</div>

            {this.state.post.model.instagram.number_of_followers ? (
                <span>
                  Reach:
                  <span className="instagram-result-data-value">
                    {' '}
                    {formatBigNumber(this.state.post.model.instagram.number_of_followers)}{' '}
                  </span>
                  {this.state.post.post.count_of_comments || this.state.post.post.count_of_likes ? ' | ' : null }
                </span>
              ) : null }

            {this.state.post.post.count_of_likes ? (
                <span>
                  Likes:
                  <span className="instagram-result-data-value">
                    {' '}
                    {formatBigNumber(this.state.post.post.count_of_likes)}{' '}
                  </span>
                  {this.state.post.post.count_of_comments ? ' | ' : null }
                </span>
              ) : null }

            {this.state.post.post.count_of_comments ? (
                <span>
                  Comments:
                  <span className="instagram-result-data-value">
                    {' '}
                    {formatBigNumber(this.state.post.post.count_of_comments)}{' '}
                  </span>
                </span>
              ) : null }

          </div>
        ) : null}
        {['story_video', 'gallery_video', 'video', 'ig_tv'].includes(this.state.post.type) ? (
          <SnapshotVideo
            sound={true}
            url={this.state.post.media.resource_url}
            ig={true}
            img={this.state.post.media.thumbnail_url}
            style={{
              maxHeight: `calc(100vh - 50px ${isFullPost ? '- 132px' : ''})`,
              display: 'block',
              border: 'none',
            }}
          />
        ) : (
          <img
            src={imageFix(this.state.post.media.resource_url)}
            alt="post"
            width="100%"
            height="100%"
            style={{
              padding: '1px',
              maxHeight: `calc(100vh - 50px ${isFullPost ? '- 132px' : ''})`,
              display: 'block',
              width: 'auto',
              margin: 'auto',
            }}
          />
        )}
      </div>,
      <div className="instagram-bottom-bar" style={{ top: this.height - 50 + 'px' }}>
        <a
          href={`https://instagram.com/${this.state.post.model.instagram.username}`}
          style={{ color: '#fff', textDecoration: 'underline' }}
          target="_blank"
          rel="noopener noreferrer"
        >
          @{this.state.post.model.instagram.username}
        </a>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (
        {formatBigNumber(this.state.post.model.instagram.number_of_followers)} followers)
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="20"
          height="20"
          viewBox="0 0 25 25"
          className="download-icon"
          onClick={() => this.download()}
        >
          <defs>
            <path
              id="a"
              d="M11.413 12.52V1c0-.553.484-1 1.082-1 .598 0 1.083.447 1.083 1v11.529l3.51-3.241a1.147 1.147 0 0 1 1.531 0l.064.059a.946.946 0 0 1 0 1.413l-5.358 4.947A1.131 1.131 0 0 1 12.5 16a1.131 1.131 0 0 1-.825-.292L6.317 10.76a.946.946 0 0 1 0-1.413l.064-.06a1.147 1.147 0 0 1 1.53 0l3.502 3.233zM23.148 17H25v1.447c0 3.191-2.492 5.787-5.556 5.787H5.556C2.492 24.234 0 21.638 0 18.447V17h1.852v1.447c0 2.127 1.661 3.858 3.704 3.858h13.888c2.043 0 3.704-1.73 3.704-3.858V17z"
            />
          </defs>
          <g fill="none" fillRule="evenodd">
            <mask id="b" fill="#fff">
              <use xlinkHref="#a" />
            </mask>
            <use fill="#EEE" xlinkHref="#a" />
            <g fill="#FFF" mask="url(#b)">
              <path d="M0 0h25v25H0z" />
            </g>
          </g>
        </svg>
      </div>,
    ];
  }
}

function mapStateToProps(state: any) {

  return {
    post: undefined
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    goTo: (url: any) => dispatch(push(url)),
    goBack: () => dispatch(goBack())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InstagramResult);
